import { inject } from '@angular/core';
import { CanActivateFn, Routes } from '@angular/router';
import { PageTitle } from '@maximizer/outlook/shared/domain';
import {
  OAuth2Service,
  PopupSessionExpiredService,
} from '@maximizer/oauth2/data-access';
import { Observable, from, map, of } from 'rxjs';
import { SyncConfigurationShellComponent } from './shell/shell.component';

// SyncConfiguration guard is separate for having a different logic than Outlook Addin
export const syncConfigurationGuard: CanActivateFn = (): Observable<boolean> => {
  const oauth = inject(OAuth2Service);
  const sessionExpired = inject(PopupSessionExpiredService);

  if (sessionExpired.expired() !== null) {
    return of(true);
  }

  if (oauth.oAuth2Token?.access_token) {
    return of(true);
  }

  return from(oauth.getStorageToken({ skipRefresh: true })).pipe(
    map((token) => {
      if (!token?.access_token) {
        sessionExpired.expire('missing-token');
      }
      return true;
    }),
  );
};

export const SYNC_CONFIGURATION_ROUTES: Routes = [
  {
    path: '',
    component: SyncConfigurationShellComponent,
    canActivate: [syncConfigurationGuard],
    title: PageTitle.SyncConfiguration,
  },
];
